import React from 'react';

import { Link } from 'react-router-dom';

import './underConstruction.scss';

const onGoBackClick = (e) => {
  e.preventDefault();

  window.history.back();

  return false;
};

const UnderConstruction = () => {
  return (
    <div className="under-construction">
      <h1> This page is under construction </h1>
      <Link to="#go-back" onClick={onGoBackClick}>
        Go back
      </Link>
    </div>
  );
};

export default UnderConstruction;



// WEBPACK FOOTER //
// ./src/containers/Help/UnderConstruction.jsx